import UserPage from "flarum/forum/components/UserPage";
import Link from "flarum/components/Link";
import humanTime from "flarum/common/helpers/humanTime";

/* global m */

const compareNames = (a, b) => {
  var nameA = a.name.toUpperCase(); // ignore upper and lowercase
  var nameB = b.name.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
};
const compareAnswers = (a, b) => {
  return b.postsPerTag - a.postsPerTag;
};

export default class PersonalAdvcommentsPane extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;

    this.fields = [];
    this.answers = {};

    this.loadUser(m.route.param("id"));
  }

  content() {
    return m(".User-Advcomments", [
      m(
        ".Fields",
        this.fields
          .map(
            ({ content, created_at, discussion_id, post_id, title, discussion_creator, tag_name, tag_slug, tag_color, tag_icon, votesSum }) => {
              const greenUpvoteClass = votesSum > 0 ? " green-upvote" : "";
              const redDownvoteClass = votesSum < 0 ? " red-downvote" : "";
              return (
                <div className="user-advcomments-item" style={"--tag-color:" + tag_color}>
                  <div className="user-advcomment-item-head">
                    <span className="TagLabelAdvcomments">
                      <i className={tag_icon} />
                      {tag_name}
                    </span>
                    <Link href={"/d/" + discussion_id}>
                      <span>{title}</span>
                    </Link>
                    <div>

                      <span className="user-advcomments-discussion-creator">{discussion_creator}</span>
                      <span className="user-advcomment-creation-date">{humanTime(created_at)}</span>
                    </div>
                  </div>
                  <div className="user-advcomment-content">
                    {content}
                  </div>
                    <div className="user-advcomment-votes">
                      <div>
                      <i className={"icon fas fa-thumbs-up Button-icon" + greenUpvoteClass}></i>
                      {votesSum}
                      <i className={"icon fas fa-thumbs-down Button-icon" + redDownvoteClass}></i>
                      </div>
                    </div>
                </div>
              );
            }
          )
      ),
    ]);
  }

  load(user) {
    app
      .request({
        method: "GET",
        url:
          app.forum.attribute("apiUrl") +
          "/personal_advcomments/" +
          user.id(),
      })
      .then(this.parseResponse.bind(this));
  }

  show(user) {
    this.load(user);

    super.show(user);
  }

  parseResponse({ jsonapi }) {
    this.answers = {};
    this.fields = jsonapi.advcomments;

    this.loading = false;
    m.redraw();
  }
}
